import "./processPolyfill.js";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import "./index.css";
import "./i18n.js";
// 必須在 React 掛載前載入：模組層要搶先接住只發一次的 beforeinstallprompt
import "./hooks/useInstallPWA.js";

// Service Worker 註冊改由 components/UpdatePrompt 負責，才能在發現新版時跳出更新提示

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
